import React, { useEffect, useState, useRef } from "react";

const DowntimeEntryInterval = ({ stopCountdown, EnableDataEntry }) => {
  const [countdown, setCountdown] = useState(null);
  const intervalRef = useRef(null); // Ref to store interval ID

  useEffect(() => {
    if (EnableDataEntry) {
      setCountdown(60);
      if (intervalRef.current) clearInterval(intervalRef.current); // Clear any existing interval

      intervalRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            stopCountdown && stopCountdown(); // Call stop function if provided
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [EnableDataEntry]);

  return (
    <div>
      <h6>Time remaining: {countdown !== null ? countdown : "Paused"} seconds</h6>
    </div>
  );
};

export default DowntimeEntryInterval;